<script>
  import Chart from "chart.js/auto";
  import { onMount } from "svelte";
  import distinctColors from "distinct-colors";

  export let hoehe;

  export let id = "1000";
  export let type = "line";
  export let line_data;

  export let barPercentage = 0.9;
  export let categoryPercentage = 0.8;

  export let show_tooltip = true;
  export let salesman_selected;
  export let redraw = false;
  export let percentage_first_axis = false;
  export let orange_first_axis = false;
  export let k = false;
  export let m = false;
  export let font_size = 8;
  export let ohne_nachkomma = false;
  export let nachkommastellen = false;
  export let add_zeichen_1 = "";

  let data = {
    labels: ["A"],
    datasets: [
      {
        data: [12],
        backgroundColor: palette_array,
        hoverBackgroundColor: palette_array,
      },
    ],
  };

  // CommonJS
  // var distinctColors_obj = require('distinct-colors').default
  var palette = distinctColors({ count: 100 }); // You may pass an optional config object
  var palette_array = [];

  let index = 1;
  palette.forEach((element) => {
    if (index > 3) {
      palette_array.push(element.toString());
    }
    index = index + 1;
  });

  const DATA_COUNT = 7;

  let labels = ["A", "B", "C", "D", "E", "F", "G"];

  function nachkommastellen_setzen(string, anzahl_komma) {
    if (!string.includes(",")) {
      return string;
    }
    return string.split(",")[0] + "," + string.split(",")[1].substring(0, anzahl_komma);
  }

  function hinter_nachkomma_entfernen(string) {
    if (!string.includes(",")) {
      return string;
    }
    return string.split(",")[0];
  }

  function replace_dot(number) {
    var s = number.toString();
    s = s.replaceAll(",", "x");
    s = s.replaceAll(".", ",");
    s = s.replaceAll("x", ".");
    return s;
  }

  const config = {
    data: data,
    options: {
      maintainAspectRatio: false,
      responsive: true,
      pointHitRadius: 20,

      scales: {
        x: {
          stacked: false,
          grid: {
            display: false,
          },
          ticks: {
            font: {
              size: font_size,
            },
          },
        },
        y: {
          gridLines: {
            drawBorder: false,
          },
          stacked: false,
          beginAtZero: true,
          position: "left",
          ticks: {
            font: {
              size: font_size,
            },
            color: orange_first_axis ? "#ffc30b" : "#545454",
            beginAtZero: true,
            callback: function (value) {
              if (k) {
                if (!m) {
                  return value / 1000;
                } else {
                  return value / 1000000;
                }
              } else {
                return value.toString() + (percentage_first_axis ? "%" : ""); // convert it to percentage
              }
            },
          },
        },
      },
      plugins: {
        title: {
          display: true,
          text: "",
        },
        tooltip: {
          mode: "index",
          enabled: show_tooltip,
          callbacks: {
            label: function (context) {
              if (context["dataset"]["label"].includes("dontshow")) {
                return false;
              }

              var add = "";
              if (percentage_first_axis && !add_zeichen_1) {
                add = "%";
              } else {
                add = add_zeichen_1;
              }

              if (nachkommastellen) {
                return (
                  context["dataset"]["label"] +
                  ": " +
                  nachkommastellen_setzen(replace_dot(context["formattedValue"]), nachkommastellen) +
                  add
                );
              }

              if (ohne_nachkomma) {
                return context["dataset"]["label"] + ": " + hinter_nachkomma_entfernen(replace_dot(context["formattedValue"])) + add;
              } else {
                return context["dataset"]["label"] + ": " + replace_dot(context["formattedValue"]) + add;
              }
            },
          },
        },
        legend: {
          display: false,
        },
      },
    },
  };

  let ctx;
  let myChart;

  let first_create = true;

  $: {
    redraw;

    if (redraw) {
      if (type == "bar") {
        //change backgroundcolor entries:

        let datasets = [];
        let i = 0;

        line_data["datasets"].forEach(function (element) {
          let t = element;
          t["backgroundColor"] = element["borderColor"];
          t["categoryPercentage"] = categoryPercentage;
          t["barPercentage"] = barPercentage;
          if ("rahmen_farbe" in t && t["rahmen_farbe"]) {
            t["borderColor"] = t["rahmen_farbe"];
            t["borderWidth"] = 1;
            console.log("t['rahmen_farbe']: ", t["rahmen_farbe"]);
          }

          i = i + 1;
          if ("rahmen_farbe" in t && t["rahmen_farbe"]) {
            console.log("t: ", t);
          }
          datasets.push(t);
        });

        if (myChart) {
          myChart.destroy();
          myChart = new Chart(ctx, {
            type: type,
            options: config["options"],
            data: {
              labels: line_data["labels"],
              datasets: datasets,
            },
            onClick: function () {},
          });
        }
      } else {
        if (myChart) {
          myChart.destroy();
          myChart = new Chart(ctx, {
            type: "line",
            options: config["options"],
            data: {
              labels: line_data["labels"],
              datasets: line_data["datasets"],
            },
            onClick: function () {},
          });
        }
      }
    }
  }

  $: {
    let data_changed = line_data;

    if (data_changed) {
      if (first_create) {
        onMount(() => {
          ctx = document.getElementById("myChart" + id.toString()).getContext("2d");

          if (type == "bar") {
            //change backgroundcolor entries:

            let datasets = [];
            let i = 0;

            line_data["datasets"].forEach(function (element) {
              let t = element;
              t["backgroundColor"] = element["borderColor"];
              t["categoryPercentage"] = categoryPercentage;
              t["barPercentage"] = barPercentage;
              if ("rahmen_farbe" in t && t["rahmen_farbe"]) {
                t["borderColor"] = t["rahmen_farbe"];
                t["borderWidth"] = 1;
                console.log("t['rahmen_farbe']: ", t["rahmen_farbe"]);
              }
              i = i + 1;
              if ("rahmen_farbe" in t && t["rahmen_farbe"]) {
                console.log("t: ", t);
              }
              datasets.push(t);
            });

            myChart = new Chart(ctx, {
              type: type,
              options: config["options"],
              data: {
                labels: line_data["labels"],
                datasets: datasets,
              },
              onClick: function () {},
            });
          } else {
            myChart = new Chart(ctx, {
              type: "line",
              options: config["options"],
              data: {
                labels: line_data["labels"],
                datasets: line_data["datasets"],
              },
              onClick: function () {},
            });
          }
          first_create = false;
        });
      }
    }
  }
</script>

<canvas id="myChart{id}" style="width:100%; min-height: 200px;" />
